import React from "react";

export const Cross = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 21 19"
    >
      <path d="M16.221 14.417a.806.806 0 010 1.166.757.757 0 01-.583.25.756.756 0 01-.583-.25l-4.417-4.416-4.417 4.416a.756.756 0 01-.583.25.756.756 0 01-.583-.25.805.805 0 010-1.166L9.47 10 5.055 5.583a.806.806 0 010-1.166.806.806 0 011.166 0l4.417 4.416 4.417-4.416a.806.806 0 011.166 0 .806.806 0 010 1.166L11.805 10l4.416 4.417z" />
    </svg>
  );
};
